[
  "A fintech startup building a payment API — strong engineering, code review, move fast",
  "Marketing agency with 5 clients — content creation, social media, brand strategy",
  "Research lab exploring LLM applications — papers, experiments, rapid prototyping",
  "SaaS startup building project management tool — focus on quality and UX"
]
